/**
 * Badge do módulo a partir de `metadata.context.module`.
 * Chave canônica (API) → label em português.
 */
export const NOTIFICATION_MODULE_LABEL_BY_KEY = {
  sale: "Vendas",
  budget: "Orçamento",
  customer: "Cliente",
  panel: "Painel",
  user: "Usuário",
  circuit: "Circuito",
  service: "Serviço",
  audit: "Auditoria",
};

/** Fallback quando module/type não resolvem. */
export const NOTIFICATION_CARD_DEFAULT_CATEGORY = "Geral";

/**
 * Fallback legado por prefixo de `type` (quando `metadata.context.module` ausente).
 * Ordem: prefixos mais específicos primeiro.
 */
export const NOTIFICATION_CATEGORY_BY_TYPE_PREFIX = [
  { prefix: "notification.budget-task", label: "Orçamento" },
  { prefix: "notification.budget", label: "Orçamento" },
  { prefix: "notification.sale", label: "Vendas" },
  { prefix: "sale", label: "Vendas" },
];
